module.exports = __webpack_public_path__ + "img/tu04.2f4d8597.png";